(function () {
  'use strict';

  if (window.__pojProductPageLoaded) return;
  window.__pojProductPageLoaded = true;

  function revealOnScroll() {
    var items = document.querySelectorAll('[data-poj-product-reveal], .poj-aura-card');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.16 });

    items.forEach(function (item, index) {
      item.style.transitionDelay = Math.min(index * 45, 360) + 'ms';
      observer.observe(item);
    });
  }

  function initProductTilt() {
    var targets = document.querySelectorAll('.poj-aura-card, .product-details > .group-block');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    targets.forEach(function (target) {
      target.addEventListener('mousemove', function (event) {
        var rect = target.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        target.style.setProperty('--poj-tilt-x', (x * 8).toFixed(2) + 'px');
        target.style.setProperty('--poj-tilt-y', (y * 8).toFixed(2) + 'px');
      });

      target.addEventListener('mouseleave', function () {
        target.style.removeProperty('--poj-tilt-x');
        target.style.removeProperty('--poj-tilt-y');
      });
    });
  }

  function init() {
    revealOnScroll();
    initProductTilt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
